import { Component } from '@angular/core';
import { AuthentificationService } from '../../services/auth/authentification.service';
import { Router, ActivatedRoute, Params, NavigationEnd } from '@angular/router';
import { StorageUtil } from '../../utils/storage.util';
import { CookieService } from 'ngx-cookie-service';

@Component({
  moduleId: module.id,
  templateUrl: 'dashboard.component.html',
  styleUrls: ['dashboard.component.css'],
  providers: []
})

export class DashboardComponent {

  sectionStatus: boolean = false;

  constructor(private authService: AuthentificationService, private router: Router, private cookieService: CookieService,) {
  }

  ngOnInit() {
    if(this.router.url === '/communications') {
      this.sectionStatus = true;
    }

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd ) {
        if(event.url === '/communications') {
          this.sectionStatus = true;
        }
      }
    });
  }

  logout($event) {
    $event.preventDefault();
    this.authService.logout();
    this.router.navigate(['/']);
  }

  ngOnDestroy() {
    StorageUtil.cleanTenantName();
    StorageUtil.cleanTenantType();
    this.cookieService.deleteAll();
  }

}



// WEBPACK FOOTER //
// ./src/app/components/dashboard/dashboard.component.ts